const currencyDisplayHelper = (value) => {
    return "₦" + parseFloat(value).toFixed(1);
}
export default currencyDisplayHelper;